import * as z from 'zod';
import { contractSuretyTypeSchema, SuretyType, SuretyQuoteStatus, contractHazardSchema, contractDamageSchema, usStateOrTerritorySchema, dateTimeSchema } from '../../../../../enums.mjs';
import '../../../../../types/actor/actor.mjs';
import '../../../../../types/address/address.mjs';
import '../../../../../types/credit-report/company-credit-report.mjs';
import '../../../../../types/credit-report/individual-credit-report.mjs';
import '../../../../../types/currency/currency.mjs';
import '../../../../../types/entityRelation/entity-relation.mjs';
import '../../../../../types/financial-formula/adjustable-value.mjs';
import '../../../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../../../types/financial-formula/adjustment.mjs';
import '../../../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../../../types/is-encrypted.mjs';
import '../../../../../types/naics-codes/naics-codes.mjs';
import { carrierName, percentSchema, naicsCodeId, city, sfaaCodeId } from '../../../../../types/opaque.mjs';
import '../../../../../types/surety/account/surety-account.types.mjs';
import '../../../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../../../types/surety/bond/surety-bond.types.mjs';
import '../../../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../../../types/surety/quote/surety-quote.types.mjs';
import '../../../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../../../types/user/user.types.mjs';
import { currencySchema } from '../../../../../types/utils.mjs';

var UpdateStatus;
(function (UpdateStatus) {
    (function (Request) {
        Request.baseSchema = z.object({
            suretyType: z.literal(SuretyType.contract),
            contractSuretyType: contractSuretyTypeSchema,
            reviewNote: z.string().nullish(),
        });
        Request.baseApproveSchema = Request.baseSchema.extend({
            status: z.literal(SuretyQuoteStatus.approved),
            agencyCommissionPercentage: percentSchema,
            carrierName: carrierName,
        });
    })(UpdateStatus.Request || (UpdateStatus.Request = {}));
})(UpdateStatus || (UpdateStatus = {}));
var Update;
(function (Update) {
    (function (Request) {
        Request.projectSchema = z.object({
            name: z.string().nullish(),
            projectNumber: z.string().nullish(),
            description: z.string().nullish(),
            city: city.nullish().meta({ partial: true }),
            state: usStateOrTerritorySchema.nullish().meta({ partial: true }),
            scopeOfWork: z
                .array(naicsCodeId)
                .nullish()
                .meta({ requiredForApproval: true, label: "Scope of work" }),
            monthsToComplete: z.coerce
                .number({ error: "Expected Number" })
                .int()
                .min(1)
                .nullish()
                .meta({ requiredForApproval: true, label: "Months to complete" }),
            contractWarrantyMonths: z.coerce
                .number({ error: "Expected Number" })
                .int()
                .min(0)
                .nullish()
                .meta({ requiredForApproval: true, label: "Contract warranty months" }),
            contractDamages: z.array(contractDamageSchema).nullish().meta({ partial: true }),
            contractHazards: z.array(contractHazardSchema).nullish().meta({ partial: true }),
        });
        Request.baseSchema = z.object({
            suretyType: z.literal("contract"),
            updatedAt: dateTimeSchema,
            bondAmount: currencySchema,
            tListingRequired: z.boolean().nullish().meta({ partial: true }),
            sfaaCodeId: sfaaCodeId.nullish().meta({ partial: true }),
            completionBond: z.boolean().nullish().meta({ partial: true }),
            project: Request.projectSchema,
        });
    })(Update.Request || (Update.Request = {}));
})(Update || (Update = {}));

export { Update, UpdateStatus };
